var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{attrs:{"name":"list-staggered","tag":_vm.tag,"css":false},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"leave":_vm.leaveAnimation}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }